/<template>
	<div class="row">
		<div class="col-12">
			<div class="row">
				<div class="col-12 titulo-paso">CSV FN Facturas (Obligatorio)</div>
			</div>
			<div class="row">
				<div class="col-12 text-right">
					<b-button id="seguir" variant="success" v-on:click="seguir" :disabled="!disabled">SEGUIR</b-button>
					<hr/>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<label class="control-label">A continuación: sube el archivo con la planilla completa</label>
					<upload-excel type="csv" :on-success="onSuccess" :before-upload="beforeUpload" />
				</div>
			</div>
			<p></p>
			<div v-if="error" class="row">
				<div class="col-12 text-center">
					<div class="row">&nbsp;</div>
					<div class="row">
						<div class="col-12">
							<h5><i class="fas fa-exclamation fa-fw" /> {{ mensaje }}</h5>
						</div>
					</div>
				</div>
			</div>	
			<div v-if="validacion" class="row">
				<div class="col-8 offset-2">
					<b-progress max=100 variant="success">
						<b-progress-bar :value="avance">{{ avance }}%</b-progress-bar>
					</b-progress>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import UploadExcel from "./upload_excel.vue"


	export default
	{
		name: "Paso2",
		components: { UploadExcel },
		props: {
			periodo: String, 
			confirmacion: false,
			onAvanzar: Function, // Funcion callback para avanzar en el wizard
			onArchivo: Function, // Funcion callback para informar sobre el archivo cargado
		},
		data() {
			return {
				nombre: "fn_facturas", // Tipo de archivo a cargar
				formato: [ "invoice_id", "code", "date", "issuer", "allows_payments?", "client_id", "client_country", "client_name", "tax_code", "value_date", "agency_id", "rectify_code", "tax_code_name", "rectify_date", "payment_id", "payment_kind", "payment_due_date", "currency", "billing_period", "payment_terms", "tax_region_state", "client_invoice_mail_recipients", "client_payer_email", "rate", "base_taxable", "tax", "invoice_amount" ],
				disabled: false, // Flag que controla cuando activar el boton SEGUIR
				validacion: false, 
				avance: 0,
				error: false, // Flag que controla cuando mostrar el mensaje de error
				mensaje: "",
			}
		},
		methods: {

			// Se ejecuta antes de comenzar a leer el archivo
			// Sirve para activar el icono de espera
			beforeUpload() {

				this.error = false

				// Activamos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

				return true
			},

			// Se ejecuta una vez que se leyo todo el archivo
			// Desactiva el icono de espera y valida el formato del archivo
			// Informa al padre (main.vue) sobre el archivo cargado para que lo agregue al listener
			// Envia el archivo al servidor 
			onSuccess(header, data, file) {

				// Ocultamos la imagen cargando
				window.event.$emit("mostrar-cargando", false)

				if (header.join() == this.formato.join()) {

					this.validacion = true
					this.procesar(file) // Enviamos el archivo al servidor

					// Llamamos a la funcion callback para enviar la info del archivo cargado
					if (this.onArchivo)
						this.onArchivo({ archivo: this.nombre, nombre: file.name, tipo: file.type, tamanio: file.size, registros: data.length, avance: 0 })

				} else {

					this.mensaje = "El formato del archivo no corresponde"
					this.error = true
					this.validacion = false 
				}
			},

			// Rutina que carga el archivo en el servidor mediante la api
			// y actualiza la barra de progreso
			// Si la carga se efectua OK, activa el boton SEGUIR
			// TODO: que hacer cuando hay error en la carga del archivo al servidor
			procesar(file) {

				var request = new FormData()
				request.append("archivo", file)

				var header = {
					"Content-Type": file.type,
					"usuario": this.$usuario, 
					"destino": this.$env,
					"proceso": "upDataFac",
					"archivo": this.nombre, 
					"periodo": this.periodo,
				}

				// Variable para usar en la funcion del callback del evento UploadProgress, para poder actualizar el avance en la barra de progreso
				var that = this

				axios.post("/faceZip", request, { 
					headers: header, 
					onUploadProgress: function(event) { that.avance = parseInt(Math.round((event.loaded / event.total) * 100)) }
				}).then(response => {

					if (response.data.estatus == "OK")
						this.disabled = true // Activamos el boton SEGUIR cuando finaliza la subida del archivo
					else {

						this.mensaje = response.data.estatus
						this.error = true
					}

				}).catch(ex => {

					console.log(ex.message)
				});
			},

			// Informa al padre (main.vue) que debe avanzar al siguiente paso, llamando a la funcion de callback
			seguir() {

				if (this.onAvanzar)
					this.onAvanzar()
			},
		}
	}

</script>
<style scoped>
</style>
